import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Gallery from "@/pages/Gallery";
import Sponsors from "@/pages/Sponsors";
import Registration from "@/pages/Registration";

function App() {
  return (
    <div className="App min-h-screen bg-[#050505] text-white font-manrope">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/galleria" element={<Gallery />} />
            <Route path="/sponsor" element={<Sponsors />} />
            <Route path="/iscrizioni" element={<Registration />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;